import { AssetGradientCardStyled } from './styled/AssetGradientCardStyled';
import { useLiteTradeAsset } from '../../../../../modules/LiteTrade/liteTradeHooks';
import { memo, MouseEventHandler, useCallback } from 'react';
import { WIDGETS } from '../../mobileWidgetsConstants';
import IconAsset from '../../../../../components/icon/IconAsset';

interface IAssetGradientCardProps {
    disabled?: boolean;
    collectionKey: string,
    symbol: string;
}

function AssetGradientCard(props: IAssetGradientCardProps) {
    const { symbol, disabled, collectionKey } = props;
    const {
        openAssetSlide,
    } = useLiteTradeAsset(symbol);

    const handleClick: MouseEventHandler<HTMLDivElement> = useCallback((e) => {
        openAssetSlide(collectionKey, WIDGETS.GRADIENT_CARDS_ICON);
    }, [collectionKey, openAssetSlide]);

    return <AssetGradientCardStyled disabled={disabled} onClick={handleClick}>
        <div className={'bg'}>
            <IconAsset className={'bg-icon'} symbol={symbol} size={72}/>
        </div>
        <IconAsset className={'icon'} symbol={symbol} size={32}/>
    </AssetGradientCardStyled>;
}

export default memo(AssetGradientCard);
